import { render, staticRenderFns } from "./WInput.vue?vue&type=template&id=3606f588&"
import script from "./WInput.vue?vue&type=script&lang=js&"
export * from "./WInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports